import colors from '@colors'

export const previewStyle = {
  width: '100%',
  height: '297mm',
  borderRadius: 8,
  borderWidth: 1,
  BorderColor: colors.gray['2'],
}
